import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUidByHandle, getProfile, UserProfile } from '../lib/profile.ts';

export default function PublicProfile() {
  const { handle } = useParams();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      if (!handle) return;
      const uid = await getUidByHandle(handle);
      if (!uid) { setNotFound(true); return; }
      const p = await getProfile(uid);
      if (!p || p.visibility === 'private') { setNotFound(true); return; }
      setProfile(p);
    })();
  }, [handle]);

  if (notFound) return <div className="p-6 text-white">Profile not found.</div>;
  if (!profile) return <div className="p-6 text-white">Loading…</div>;

  const links = profile.links || {};

  return (
    <div className="p-6 text-white max-w-4xl mx-auto">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-16 h-16 rounded-full bg-white/20 overflow-hidden">
          {profile.photoURL ? <img src={profile.photoURL} alt="avatar" className="w-full h-full object-cover"/> : null}
        </div>
        <div>
          <div className="text-2xl font-bold">{profile.displayName || profile.handle}</div>
          {profile.bio && <div className="opacity-80 text-sm">{profile.bio}</div>}
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-6">
        {Object.entries(links).filter(([_,v])=>v).map(([k,v]) => (
          <a key={k} href={v as string} target="_blank" rel="noreferrer" className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded text-sm">{k}</a>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white/10 rounded p-4">
          <div className="opacity-80 text-sm">Owned</div>
          <div className="text-2xl font-semibold">{profile.stats?.owned ?? '—'}</div>
        </div>
        <div className="bg-white/10 rounded p-4">
          <div className="opacity-80 text-sm">Wanted</div>
          <div className="text-2xl font-semibold">{profile.stats?.wanted ?? '—'}</div>
        </div>
        <div className="bg-white/10 rounded p-4">
          <div className="opacity-80 text-sm">Sets Completed</div>
          <div className="text-2xl font-semibold">{profile.stats?.setsCompleted ?? '—'}</div>
        </div>
      </div>

      {profile.featuredKeys && profile.featuredKeys.length > 0 && (
        <div className="mt-6">
          <div className="text-xl font-semibold mb-2">Showcase</div>
          <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
            {profile.featuredKeys.map((k) => (
              <div key={k} className="bg-white/10 rounded aspect-[2/3]" />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


